import React, { useState, useCallback } from 'react';
import { MagnifyingGlassIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/base-components';
import { IconWrapper, StyledInputText } from './index.styles';

interface Props {
  onSearch: (searchTerm: string) => void;
}

const PreconfiguredMessagesSearch: React.FC<Props> = ({ onSearch }) => {
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const Icon = () => (
    <IconWrapper isInputFocused={isInputFocused}>
      <MagnifyingGlassIcon height={16} width={16} />
    </IconWrapper>
  );

  const handleInputFocus = () => {
    setIsInputFocused(prev => !prev);
  };

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setSearchTerm(value);
      onSearch(value);
    },
    [onSearch],
  );

  return (
    <Box width="100%">
      <StyledInputText
        id="preconfigured-messages-search"
        data-name="preconfigured-messages-search"
        placeholder="Search message title or message body"
        type="text"
        value={searchTerm}
        onChange={handleChange}
        shouldDisplayClearButton={false}
        IconLeft={Icon}
        onFocus={handleInputFocus}
        onBlur={handleInputFocus}
      />
    </Box>
  );
};

export default PreconfiguredMessagesSearch;
